import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export function LanguageSwitcher({ className = "" }) {
  const { language, setLanguage } = useLanguage();
  return (
    <div
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5 ${className}`}
      data-testid="lang-switcher"
      role="group"
      aria-label="Language switcher"
    >
      <button
        type="button"
        onClick={() => setLanguage("en")}
        data-testid="lang-en-btn"
        className={`min-h-[32px] rounded-full px-3 text-xs font-semibold transition-colors ${
          language === "en" ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900"
        }`}
        aria-pressed={language === "en"}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage("hi")}
        data-testid="lang-hi-btn"
        className={`min-h-[32px] rounded-full px-3 text-xs font-semibold transition-colors ${
          language === "hi" ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900"
        }`}
        aria-pressed={language === "hi"}
      >
        हिंदी
      </button>
    </div>
  );
}
